export enum AttachmentCategory {
  'SPECIFICATION' = 'SPECIFICATION',
  'DESIGN_DRAWINGS' = 'DESIGN_DRAWINGS',
  'ENGINEERING_DRAWINGS' = 'ENGINEERING_DRAWINGS',
  'FOUNDATION_REPORTS' = 'FOUNDATION_REPORTS',
  'SPECIAL_CONDITIONS' = 'SPECIAL_CONDITIONS',
  'PURCHASE_ORDER' = 'PURCHASE_ORDER',
  'LOAN_APPROVAL' = 'LOAN_APPROVAL',
  'OFF_PLATFORM' = 'OFF_PLATFORM',
  'CERTIFICATES' = 'CERTIFICATES',
  'CONTRACT_CERTIFICATE_OF_SIGNING' = 'CONTRACT_CERTIFICATE_OF_SIGNING',
  'NOTICES' = 'NOTICES',
  'CONTRACT_PRICE_BREAKDOWN' = 'CONTRACT_PRICE_BREAKDOWN',
  'CLAIM_SUBMISSION' = 'CLAIM_SUBMISSION',
  'CLAIM_ASSESSMENT_REPORT' = 'CLAIM_ASSESSMENT_REPORT',
  'CLAIM_ASSESSMENT' = 'CLAIM_ASSESSMENT',
  'BANK_GUARANTEE' = 'BANK_GUARANTEE',
  'PERIODIC_VARIATION' = 'PERIODIC_VARIATION',
  'SITE_INFORMATION' = 'SITE_INFORMATION',
  'PRACTICAL_COMPLETION' = 'PRACTICAL_COMPLETION',
  'DEFECTS_LIABILITY_PERIOD' = 'DEFECTS_LIABILITY_PERIOD',
  'REPORTS' = 'REPORTS',
  'QUALITY_ASSURANCE' = 'QUALITY_ASSURANCE',
  'INVOICE' = 'INVOICE',
  'OTHER' = 'OTHER',
}

export enum BankGuaranteeCategory {
  'PRACTICAL_COMPLETION' = 'PRACTICAL_COMPLETION',
  'DEFECTS_LIABILITY_PERIOD' = 'DEFECTS_LIABILITY_PERIOD',
}

export enum UploadStatus {
  WAITING = 'WAITING',
  UPLOADING = 'UPLOADING',
  UPLOAD_SUCCESS = 'UPLOAD_SUCCESS',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
}

export const attachmentCategoryLabelMap = {
  [AttachmentCategory.SPECIFICATION]: 'Specification',
  [AttachmentCategory.DESIGN_DRAWINGS]: 'Design Drawings',
  [AttachmentCategory.ENGINEERING_DRAWINGS]: 'Engineering Drawings',
  [AttachmentCategory.FOUNDATION_REPORTS]: 'Foundation Reports',
  [AttachmentCategory.SPECIAL_CONDITIONS]: 'Special Conditions',
  [AttachmentCategory.PURCHASE_ORDER]: 'Purchase Order',
  [AttachmentCategory.LOAN_APPROVAL]: 'Loan Approval',
  [AttachmentCategory.OFF_PLATFORM]: 'Off Platform',
  [AttachmentCategory.CERTIFICATES]: 'Certificates',
  [AttachmentCategory.CONTRACT_CERTIFICATE_OF_SIGNING]: 'Contract Certificate of Signing',
  [AttachmentCategory.NOTICES]: 'Notices',
  [AttachmentCategory.CONTRACT_PRICE_BREAKDOWN]: 'Contract Price Breakdown',
  [AttachmentCategory.CLAIM_SUBMISSION]: 'Claim Submission',
  [AttachmentCategory.CLAIM_ASSESSMENT_REPORT]: 'Claim Assessment Report',
  [AttachmentCategory.CLAIM_ASSESSMENT]: 'Claim Assessment',
  [AttachmentCategory.BANK_GUARANTEE]: 'Bank Guarantee',
  [AttachmentCategory.PERIODIC_VARIATION]: 'Periodic Variation',
  [AttachmentCategory.SITE_INFORMATION]: 'Site Information',
  [AttachmentCategory.PRACTICAL_COMPLETION]: 'Practical Completion',
  [AttachmentCategory.DEFECTS_LIABILITY_PERIOD]: 'Defects Liability Period',
  [AttachmentCategory.REPORTS]: 'Reports',
  [AttachmentCategory.QUALITY_ASSURANCE]: 'Quality Assurance',
  [AttachmentCategory.INVOICE]: 'Invoice',
  [AttachmentCategory.OTHER]: 'Other',
};
